import { createSession } from '../session/session'
import { warn } from '../logger/logger'

export default function (cb: Function) {
  if (!(`${process.env.ENVIRONMENT}`.indexOf('production') > -1)) {
    warn(`You are using a non-production suitable integration of On-site Messaging.
      \n If this is your production environment please check https://docs.klarna.com/on-site-messaging/osm-go-live-check-list/`)
  }

  createSession()

  cb()
}
